export default function HotelDetailsShimmer() {
    return (
        <div className="max-w-7xl mx-auto mt-6 bg-white rounded-2xl shadow-md p-4 flex flex-col lg:flex-row gap-4 animate-pulse">
            {/* Left Gallery Section */}
            <div className="flex-1">
                {/* Main Image Loader */}
                <div className="relative rounded-xl overflow-hidden">
                    <div className="w-full h-80 bg-gray-200 rounded-xl" />

                    {/* Arrows (fake buttons) */}
                    <div className="absolute left-3 top-1/2 -translate-y-1/2 bg-gray-300 p-2 rounded-full" />
                    <div className="absolute right-3 top-1/2 -translate-y-1/2 bg-gray-300 p-2 rounded-full" />
                </div>

                {/* Thumbnail Loader - Horizontal Scroll */}
                <div className="flex gap-2 mt-3 overflow-x-auto pb-2">
                    {[...Array(5)].map((_, i) => (
                        <div
                            key={i}
                            className="h-20 w-32 bg-gray-200 rounded-xl flex-shrink-0"
                        />
                    ))}
                </div>
            </div>

            {/* Right Content Section */}
            <div className="w-full lg:w-[380px] flex flex-col justify-between border-l border-gray-100 pl-4">
                <div>
                    {/* Title */}
                    <div className="h-6 bg-gray-200 rounded w-3/4 mb-3" />

                    {/* Location */}
                    <div className="h-4 bg-gray-200 rounded w-5/6 mb-3" />

                    {/* Rating */}
                    <div className="flex items-center gap-3 mt-2">
                        <div className="h-5 w-10 bg-gray-200 rounded-md" />
                        <div className="h-4 w-24 bg-gray-200 rounded" />
                    </div>

                    {/* Room Type */}
                    <div className="mt-4">
                        <div className="h-4 bg-gray-200 rounded w-2/3 mb-2" />
                        <div className="h-3 bg-gray-200 rounded w-1/3" />
                    </div>

                    {/* Price Section */}
                    <div className="mt-4">
                        <div className="flex items-end gap-3">
                            <div className="h-4 w-12 bg-gray-200 rounded" />
                            <div className="h-6 w-20 bg-gray-200 rounded" />
                        </div>
                        <div className="h-3 w-1/2 bg-gray-200 rounded mt-2" />
                    </div>

                    {/* Amenities */}
                    <div className="mt-6 space-y-2">
                        {[...Array(5)].map((_, i) => (
                            <div key={i} className="flex items-center gap-2">
                                <div className="h-4 w-4 bg-gray-200 rounded-full" />
                                <div className="h-4 w-1/2 bg-gray-200 rounded" />
                            </div>
                        ))}
                    </div>
                </div>

                {/* Buttons + Offer */}
                <div className="mt-6 flex flex-col gap-3">
                    <div className="h-10 bg-gray-200 rounded-full" />
                    <div className="h-10 bg-gray-200 rounded-full" />
                    <div className="h-8 bg-gray-100 rounded-lg" />
                </div>
            </div>
        </div>
    );
}
